import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

interface CollapsibleProps extends React.PropsWithChildren {
  open?: boolean;
  className?: string;
}

function Collapsible({ open = true, className, children }: CollapsibleProps) {
  const animationRef = useRef<HTMLDivElement>(null);
  const [isAnimating, setIsAnimating] = useState<boolean>(false);
  const [animationHeight, setAnimationHeight] = useState<number>(10000);

  useEffect(() => {
    const animationEnd = () => {
      setIsAnimating(false);
    };
    const target = animationRef.current;
    target?.addEventListener('transitionend', animationEnd);
    return () => {
      target?.removeEventListener('transitionend', animationEnd);
    };
  }, [animationRef]);

  useEffect(() => {
    const handleResize = () => {
      if (animationRef.current) {
        setAnimationHeight(animationRef.current.scrollHeight + 100);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [animationRef]);

  useEffect(() => {
    if (animationRef.current) {
      setAnimationHeight(animationRef.current.scrollHeight + 100);
    }
    setIsAnimating(true);
  }, [animationRef, open]);

  return (
    <div
      ref={animationRef}
      style={{
        maxHeight: open ? animationHeight : 0,
        overflow: !open || isAnimating ? 'hidden' : '',
      }}
      className={classNames(
        'transition-maxHeight duration-1000',
        className,
        (!open || isAnimating) && 'overflow-hidden'
      )}
    >
      {children}
    </div>
  );
}

export default Collapsible;
